import React from 'react'
import Location from '../models/Location.js';
//import RentalLocation from '../models/RentalLocation.js';
import DatePicker from "react-datepicker";
import RezCentral from '../components/RezCentral.js';
import SCR from '../components/SCR.js';
import {Container, Row, Col, Form, Button, Stack} from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";

export default class Step1 extends React.Component {
  //rental_locations = [];

  constructor(props){
      super(props);

      this.state = {
        rentalLocations : [],
        discountCodes : [],
        //loading : false,
        //pickupLocationId : '', // combined id and city for select
        //dropoffLocationId : '', // combined id and city for select

        // form data
        pickupLocationCity : '',
        pickupLocationId : '',
        pickupDate : '',
        pickupTime : '',
        dropoffLocationCity : '',
        dropoffLocationId : '',
        dropoffDate : '',
        dropoffTime : '',
        discountCode : '',
        extras : [],
        age : 25,
        errors : {},
        errorMessage : ''
      };

      // call bind to use this in function
      this.getRates = this.getRates.bind(this);
      this.handleInputChange = this.handleInputChange.bind(this);
      this.modifyRez = this.modifyRez.bind(this);
      this.validateDiscountCode = this.validateDiscountCode.bind(this);
      this.getLocationTime = this.getLocationTime.bind(this);
  }

 componentDidUpdate(){
    SCR.resizeParent();
 }

 componentDidMount() {
    var self = this;

    RezCentral.getLocations()
    .then(data => {
      //console.log(data.data.rentalLocation)
      self.setState({
          rentalLocations : data.data.rentalLocation,
          discountCodes : data.data.discountCode,

          // preset data
          pickupLocationCity : SCR.getCity(this.props.pickup.locationId) || '',
          pickupLocationId : this.props.pickup.locationId  || '',
          pickupDate : this.props.pickup.date || '',
          pickupTime : this.props.pickup.time || '',
          dropoffLocationCity : SCR.getCity(this.props.dropoff.locationId) || '',
          dropoffLocationId : this.props.dropoff.locationId || '',
          dropoffDate : this.props.dropoff.date || '',
          dropoffTime : this.props.dropoff.time || '',
          discountCode : this.props.discountCode || '',
          age : this.props.age || this.state.age || '',
          extras : this.props.extras || []
      }, () => {
        //SCR.resizeParent();
      });
    });


    var page = "/reservation";
    window.history.replaceState(null, "Savannah Car Rentals Reservation", page);
    SCR.fireTracking(page, {});

    // send fb and google tracking
    /*if (typeof window !== "undefined") {
      if (window.fbq != null)
        window.fbq('track', 'PageView');
      //  window.fbq('track', 'ViewContent', { content_name : "Reservation Home", value : "Reservation"});

      if (window.gtag != null)
        window.gtag('config', 'UA-12341353-18');*/
        /*window.gtag('config', 'UA-12341353-18', {
          'page_title' : 'Savannah Car Rentals Reservation',
          'page_path': '/reservation'
        });*/
    //}
  }

  getRates(e){
    e.preventDefault();

    // check that fields are filled out
    if (this.validateFormInputs()) {
      this.setState({errors : {}, errorMessage : ''});
      //var pu = this.state.pickupLocation.split('|');

      var dt = new Date();
      var pickup = new Location();
      pickup.locationCity = SCR.getCity(this.state.pickupLocationId);
      pickup.locationId = this.state.pickupLocationId;
      pickup.date = this.state.pickupDate;
      pickup.time = this.state.pickupTime || this.getLocationTime('open', this.state.pickupLocationId, this.state.pickupDate, dt.getTime());

      //var dro = this.state.dropoffLocation.split('|');
      var dropoff = new Location();
      dropoff.locationCity = SCR.getCity(this.state.dropoffLocationId);
      dropoff.locationId = this.state.dropoffLocationId;
      dropoff.date = this.state.dropoffDate;
      dropoff.time = this.state.dropoffTime || this.getLocationTime('open', this.state.dropoffLocationId, this.state.dropoffDate, dt.getTime());
      //console.log('dropoff Date = ' + this.state.dropoffDate)
      //console.log('dropoff time = ' + dropoff.time)
      var discountCode = this.state.discountCode;
      var age = this.state.age;
      var extras = this.state.extras;

      this.props.setLocationDetails(pickup, dropoff, discountCode, age, extras);
    }
  }

  validateFormInputs(){
    //let fields = this.state.fields;
    var pickupLocationId = this.state.pickupLocationId;
    var pickupDate = this.state.pickupDate;
    //var pickupTime = this.state.pickupTime;

    var dropoffLocationId = this.state.dropoffLocationId;
    var dropoffDate = this.state.dropoffDate;
    //var dropoffTime = this.state.dropoffTime;
    var age = this.state.age;

    let errors = {};
    let errorMessage = '';
    let formIsValid = true;

    if (!pickupLocationId) {
      formIsValid = false;
      errors.pickupLocationId = "Cannot be empty";
    }

    if (!pickupDate) {
      formIsValid = false;
      errors.pickupDate = "Cannot be empty";
    }

    //if (!pickupTime) {
      //formIsValid = false;
      //errors.pickupTime = "Cannot be empty";

      //set pickup time to location open by default
      //pickupTime = this.getLocationTime('open', this.state.pickupLocationId, this.state.pickupDate);

    var dt = new Date();
    // check that open is not empty which means there are no open times for pickup today
    let open = parseInt(this.getLocationTime('open', this.state.pickupLocationId, this.state.pickupDate, dt.getTime(), true).replace(':', '').replace(' AM', '').replace(' PM', ''));
    //let close = parseInt(this.getLocationTime('close', this.state.pickupLocationId, this.state.pickupDate, dt.getTime(), true).replace(':', '').replace(' AM', ''));

    if((pickupLocationId && pickupDate) && isNaN(open)){
      formIsValid = false;
      errors.pickupTime = "Invalid date";
      errorMessage = 'No pick up times available for that date.  Please choose another date.';
    }
    //}
    if (!dropoffLocationId) {
      formIsValid = false;
      errors.dropoffLocationId = "Cannot be empty";
    }

    if (!dropoffDate) {
      formIsValid = false;
      errors.dropoffDate = "Cannot be empty";
    }

    /*if (!dropoffTime) {
      //formIsValid = false;
      //errors.dropoffTime = "Cannot be empty";

      //set dropoff time to location open by default
      dropoffTime =  this.getLocationTime('open', this.state.dropoffLocationId, this.state.dropoffDate);
      updateState = true;
    }*/

    if (!age) {
      formIsValid = false;
      errors.age = "Cannot be empty";
    }

    this.setState({ errors: errors, errorMessage : errorMessage.length > 0 ? errorMessage : 'The form has errors, please fix and submit again' }, () => {
      //SCR.resizeParent();
    });
    return formIsValid;
  }

  validateDiscountCode(event){
    const target = event.target;
    const discountCode = target.value;
    var isValid = false;

    // prevent not being able to edit field
    this.setState({ discountCode : discountCode});

    if(discountCode.length > 3){
      var discountCodes = this.state.discountCodes;
      discountCodes.forEach(discount => {
        //console.log(discount.code.toLowerCase() === discountCode.toLowerCase())
        if(discount.code.toLowerCase() === discountCode.toLowerCase())
          isValid = true;
      });

      if(!isValid)
        this.setState({ errors: { discountCode : "Invalid discount code"}, errorMessage : 'Invalid discount code' });
      else {
        this.setState({
          errors : {},
          errorMessage : '',
          discountCode : discountCode
        });
      }
    }else{
      this.setState({
        errors : {},
        errorMessage : '',
        discountCode : discountCode
      });
    }
  }

  handleInputChange(event){
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

    if(name === 'pickupLocationId')
      this.setState({
        dropoffLocationId : value
      });
    else if(name === 'pickupTime')
      this.setState({
        dropoffTime : value
      });
  }

  getLocationTime(openOrClose, locationId, date, currentTime, twentyFourHr){
    //console.log('locationId = ' + locationId)
    //console.log('date = ' + date)
    var time = '';

    if(twentyFourHr === null)
      twentyFourHr = false;

    if(typeof this.state.rentalLocations !== 'undefined'){
      var locations = this.state.rentalLocations;
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var day = 0;
      locations.forEach(location => {
        //console.log('rLocationID'+location.rentalLocationID)
        if(location.rentalLocationID === locationId){
          day = days[date.getDay()];
          //console.log('day = '+ day)
          if(location.businessHours['openClose' + day] !== ''){
            var tmp = location.businessHours['openClose' + day].split('-');
            if(openOrClose === 'open'){
              var openHours = tmp[0].substring(0,2);
              var openMinutes = tmp[0].substring(2,4);
              if(this.isToday(date)){ // todays date so round to the nearest future time - past times are not shown
                //const dt = new Date();
                //const minutes = 30;
                const ms = 1000 * 60 * 30;
                let roundedDate = new Date(Math.ceil(currentTime / ms) * ms);
                //console.log('roundedDate = '+ roundedDate)
                var closeHours = tmp[1].substring(0,2);
                var closeMinutes = tmp[1].substring(2,4);
                if(parseInt(('0' + roundedDate.getHours()).slice(-2) + '' + ('0' + roundedDate.getMinutes()).slice(-2)) > parseInt((openHours + '' + openMinutes)) &&
                (parseInt(('0' + roundedDate.getHours()).slice(-2) + '' + ('0' + roundedDate.getMinutes()).slice(-2)) < parseInt(closeHours + '' + closeMinutes))
                )
                  time = ('0' + roundedDate.getHours()).slice(-2) + ':' + ('0' + roundedDate.getMinutes()).slice(-2) + (roundedDate.getHours() < 12 ? ' AM' : ' PM');
                else if (roundedDate.getHours() >= parseInt(closeHours))
                  time = '';
                else
                  time = openHours + ':' + openMinutes + ' AM';
              }else
                time = openHours + ':' + openMinutes + ' AM';
            }else{
              var hour = parseInt(tmp[1].substring(0,2));
              if(!twentyFourHr){
                if(hour > 12)
                  hour = hour - 12;
              }
              var minute = tmp[1].substring(2,4)
              time = ('0' + hour).slice(-2) + ':' + minute + ' PM';
            }
          }
        }
      });
    }
//console.log(openOrClose + " time = " + time)
    return time;
  }

  generateTimeOptions(open, close, key){
    /*var isAfterHours = false;
    if(isNaN(open) && isNaN(close)){
      open = 0;
      close = 2330;
      isAfterHours = true;
    }*/

    var hours, minutes = 0;
    var timestr, ampm = '';
    var output = [];

    for(var i = open; i <= close; i = i + 10){
      if(i < 1000){
        hours = i.toString().substring(0,1);
        minutes = i.toString().substring(1,3);
      }else{
        hours = i.toString().substring(0,2);
        minutes = i.toString().substring(2,4);
      }

      if(minutes === '00' || minutes === '30'){
        if(parseInt(hours) === 12){
          ampm = 'PM';
        }else if(parseInt(hours) > 12){
          hours = ('0' + (parseInt(hours) - 12)).slice(-2);
          ampm = 'PM';
        }else{
          hours = ('0' + hours).slice(-2);
          ampm = 'AM';
        }

        timestr = hours + ':' + minutes + ' ' + ampm;
        output.push(<option key={key + '_' + timestr} value={timestr}>{timestr}</option>);
      }
    }

    return output;
  }

  modifyRez(){
      this.props.modifyRez();
  }

  isToday(dt){
    var date = new Date();
    if((dt.getMonth() === date.getMonth())
      && (dt.getDate() === date.getDate())
      && (dt.getFullYear() === date.getFullYear())
    )
      return true;
    else {
      return false;
    }
  }

  render(){
    //console.log('COMPONENT IS RENDERING *****')
    var startDate = new Date();

    var PickupTimes, DropoffTimes = [];
    if(typeof this.state.pickupLocationId !== 'undefined' && this.state.pickupDate !== ''){
      let open = parseInt(this.getLocationTime('open', this.state.pickupLocationId, this.state.pickupDate, startDate.getTime(), false).replace(':', '').replace(' AM', ''));
      let close = parseInt(this.getLocationTime('close', this.state.pickupLocationId, this.state.pickupDate, startDate.getTime(), true).replace(':', '').replace(' AM', ''));
      //console.log(open + ' ' + this.state.pickupDate)
      //console.log(close)
      PickupTimes = this.generateTimeOptions(open, close, 'pickup');
    }
    //console.log(this.state.dropoffLocationId)
    //console.log(this.state.dropoffDate)
    if(typeof this.state.dropoffLocationId !== 'undefined' && this.state.dropoffDate !== ''){
      let open = parseInt(this.getLocationTime('open', this.state.dropoffLocationId, this.state.dropoffDate, startDate.getTime(), false).replace(':', '').replace(' AM', ''));
      let close = parseInt(this.getLocationTime('close', this.state.dropoffLocationId, this.state.dropoffDate, startDate.getTime(), true).replace(':', '').replace(' AM', ''));
      //console.log(open)
      /*console.log('id = '+this.state.pickupLocationId)
      console.log('id = '+this.state.dropoffLocationId)
      console.log('dropoff date = ' + this.state.dropoffDate)
      console.log('CLOSE = '+close)*/
      //if(!isNaN(open) && !isNaN(close))
      DropoffTimes = this.generateTimeOptions(open, close, 'dropoff');
      //else
      //  DropoffTimes = this.generateTimeOptions(open, close, 'dropoff');
        //DropoffTimes = <option value="">Closed</option>;
    }

    var Locations = [];
    if(typeof this.state.rentalLocations !== "undefined"){
      Locations = this.state.rentalLocations.map(
        location => {
          //console.log(location.businessHours);
          var isOpen = false;
          if(location.businessHours.openCloseMon !== "" ||
            location.businessHours.openCloseTue !== "" ||
            location.businessHours.openCloseWed !== "" ||
            location.businessHours.openCloseThu !== "" ||
            location.businessHours.openCloseFri !== "" ||
            location.businessHours.openCloseSat !== ""
          )
            isOpen = true;

          if(isOpen)
            return <option value={location.rentalLocationID} key={location.rentalLocationID}>{location.addressCity}</option>
          else
            return "";
        }
      );
    }

    //console.log('DATE PIKCER CHANGE *****' + PickupTimes)
    //console.log('DATE PIKCER CHANGE *****' + DropoffTimes)

    // filter out sundays (closed)
    const notSunday = (date) => {
      const day = date.getDay();
      return day !== 0;//&& day !== 6;
    };

    //console.log('pickup date = '+this.state.pickupDate)

    return (
        <Container fluid id="rez-container">
          <Row xs={1} sm={2}>
          <Col id="rez-left">
            <h3 className="step-header">
              <span className="circle-num">1</span>
              <small>Make your Reservation Now</small>
            </h3>
            <h6>Pick up</h6>
            <Form.Select
              name="pickupLocationId"
              onChange={this.handleInputChange}
              value={this.state.pickupLocationId}
              className={this.state.errors.pickupLocationId ? 'error' : ''}
            >
              <option value="">- Select Pick up Location -</option>
              {Locations}
            </Form.Select>

            <Row className="mt-3 mb-3">
              <Col xs={6} md={7}>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  //startDate={startDate}
                  selected={this.state.pickupDate}
                  filterDate={notSunday}
                  minDate={startDate}
                  onChange={(date) => {
                    var dropoff = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    dropoff.setDate(dropoff.getDate() + 1);
                    if(!notSunday(dropoff))
                      dropoff.setDate(dropoff.getDate() + 1);

                    this.setState({
                      pickupDate: date,
                      dropoffDate : dropoff
                    }/*, ()=> {this.getLocationTime('close', this.state.pickupLocationId, this.state.pickupDate)}*/)
                  }}
                  selectsStart
                  placeholderText="Pickup Date"
                  className={this.state.errors.pickupDate ? 'form-control error' : 'form-control'}
                />
              </Col>
              <Col>
                <Form.Select
                  name="pickupTime"
                  onChange={this.handleInputChange}
                  value={this.state.pickupTime}
                  className={this.state.errors.pickupTime ? 'error' : ''}>
                  <option value="">Pickup Time</option>
                  {PickupTimes}
                </Form.Select>
              </Col>
            </Row>

            <h6>Drop off</h6>
            <Form.Select
              name="dropoffLocationId"
              onChange={this.handleInputChange}
              value={this.state.dropoffLocationId}
              className={this.state.errors.dropoffLocationId ? 'error' : ''}
            >
              <option value="">- Select Pick up Location -</option>
              {Locations}
            </Form.Select>

            <Row className="mt-3 mb-3">
              <Col xs={6} md={7}>
                <DatePicker
                  dateFormat="yyyy-MM-dd"
                  //startDate={startDate}
                  //endDate={this.state.dropoffDate}
                  selected={this.state.dropoffDate}
                  filterDate={notSunday}
                  minDate={startDate}
                  onChange={(date) =>
                    this.setState({
                      dropoffDate: date
                    })
                  }
                  selectsEnd
                  placeholderText="Dropoff Date"
                  className={this.state.errors.dropoffDate ? 'form-control error' : 'form-control'}
                />
              </Col>
              <Col>
                <Form.Select
                  name="dropoffTime"
                  onChange={this.handleInputChange}
                  value={this.state.dropoffTime}
                >
                  <option value="">Dropoff Time</option>
                  {DropoffTimes}
                </Form.Select>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <h6>Renter Age</h6>
                <Form.Select
                  name="age"
                  onChange={this.handleInputChange}
                  value={this.state.age}
                  className={this.state.errors.age ? 'error form-select form-select-sm' : 'form-select form-select-sm'}>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                  <option value="25">25+</option>
                </Form.Select>
              </Col>
              <Col className="added-charge">* Charge will be added for under 25</Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <h6>Coupon Code/Corporate ID</h6>
                <Form.Control type="text" name="discountCode" value={this.state.discountCode} onChange={this.validateDiscountCode} className={this.state.errors.discountCode ? 'error' : ''} ></Form.Control>
                <br/>
                <br/>
                <Row>
                  <Col className="d-md-flex justify-content-md-end">
                    <Button id="getRates" onClick={this.getRates}>Get Rates</Button>
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col className="text-danger fs-5">{this.state.errorMessage}</Col>
                </Row>
              </Col>
            </Row>
          </Col>

          <Col id="rez-right">
            <span className="modify-rez"><Button onClick={this.modifyRez} className="rez-link">Modify</Button> or <Button onClick={this.modifyRez} className="rez-link">Cancel</Button> your Reservation</span>
            <h4>Book your Vehicle in four easy steps</h4>
            <Stack gap={4}>
              <div><h5><span className="circle-num">1</span>Select your Date and Destination</h5></div>
              <div><h5><span className="circle-num">2</span>Choose your Vehicle</h5></div>
              <div><h5><span className="circle-num">3</span>Choose your Protector Plan and Extras</h5></div>
              <div><h5><span className="circle-num">4</span>Review and Send your information</h5></div>
            </Stack>
          </Col>
        </Row>
      </Container>
    );
  }
}
